/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { axiosInstance } from "../../utils/axiosInstance";
import { selectedServicesNew } from "../../Slice/serviceSlice";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

/* eslint-disable jsx-a11y/anchor-is-valid */
const Nearby = ({ id, filter_category_id }) => {
  const category_id = id?.[0]?.provider_category?.id ?? filter_category_id;
  const dispatch = useDispatch();
  const data = useSelector((state) => state);

  const Navigate = useNavigate();

  const [providers, setproviders] = useState([]);
  const { Provider } = useSelector((state) => state.auth);
  const ServiceAvibility = (id, data) => {
    localStorage.clear('category')
    Navigate(`/services/${id}`, { state: data });
  };

  // useEffect(() => {
  //   const fetchProviders = async () => {
  //     await axiosInstance
  //       .get(`provider?category_id=${category_id}`)
  //       .then((res) => {
  //         setproviders(res.data.data);
  //       })
  //       .catch((err) => console.log(err));
  //   };
  //   fetchProviders();
  // }, [category_id]);

  useEffect(() => {
    const fetchAllProviders = async () => {
      await axiosInstance
        .get(`https://studioapi.dev-sh.xyz/api/provider`)
        .then((res) => {
          setproviders(res.data.data);
        })
        .catch((err) => console.log(err));
    };
    fetchAllProviders();
  }, []);
  return (
    <div className="latest-posts">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            {/* Section Title Start */}
            <div className="section-title">
              <h3 className="wow fadeInUp">Nearby Businesses</h3>
            </div>
            {/* Section Title End */}
          </div>
        </div>
        <div className="row">
          {providers?.length > 0 ? (
            providers.map((p, idx) => (
              <div
                className="col-lg-4"
                onClick={() =>
                  dispatch(
                    selectedServicesNew({
                      ...Provider,
                      provider_category_detail: p,
                    })
                  )
                }
                key={idx}
                style={{ marginBottom: "15px" }}
              >
                {/* Post Item Start */}
                <div
                  className="post-item wow fadeInUp"
                  onClick={() => ServiceAvibility(p?.id, data)}
                  data-wow-delay="0.5s"
                >
                  {/* Post Featured Image Start */}
                  <div className="post-featured-image">
                    <figure className="hover-anime">
                      <img
                        src={p.image}
                        alt=""
                        height={300}
                        width={500}
                        style={{ objectFit: "cover" }}
                      />
                    </figure>
                  </div>
                  {/* Post Featured Image End */}
                  {/* Post Header Start */}
                  <div className="post-header">
                    <h3>
                      {/* <Link to={`/services/${p.id}`} state={p}> */}
                      {p.first_name}
                      {/* </Link> */}
                    </h3>
                    <div className="post-meta">
                      <ul>
                        <li>
                          {/* <Link to={`/services/${p.id}`} state={p}> */}
                          {p.about}
                          {/* </Link> */}
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* Post Header End */}
                  {/* Post Read More Button Start */}
                  <div className="post-readmore">
                    {/* <Link to={`/services/${p.id}`} state={p}> */}
                    <img src="assests/images/icon-readmore.svg" alt="" />
                    {/* </Link> */}
                  </div>
                  {/* Post Read More Button End */}
                </div>
                {/* Post Item End */}
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>No business nearby</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Nearby;
